import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";
import z from "zod";

export const DEFAULT_ACTIVITY_DURATION_MINUTES = 15;

export const durationOptions = ["5", "15", "30", "custom"] as const;
export const durationOptionSchema = z.enum(durationOptions);
export type IDurationOption = z.infer<typeof durationOptionSchema>;

export const DEFAULT_ACTIVITY_DURATION_OPTION: IDurationOption = "15";

type DurationConfig = {
  displayText: MessageDescriptor;
  numberOfMinutes: number | null; // null for custom
};

export const durationDictionary: Record<IDurationOption, DurationConfig> = {
  "5": {
    displayText: msg`5 min`,
    numberOfMinutes: 5,
  },
  "15": {
    displayText: msg`15 min`,
    numberOfMinutes: 15,
  },
  "30": {
    displayText: msg`30 min`,
    numberOfMinutes: 30,
  },
  custom: {
    displayText: msg`Annan tid`,
    numberOfMinutes: null,
  },
};

export const customDurationUnitOptions = ["minutes", "hours"] as const;
export const customDurationUnitSchema = z.enum(customDurationUnitOptions);
export type ICustomDurationUnit = z.infer<typeof customDurationUnitSchema>;

export const customDurationUnitDictionary: Record<
  ICustomDurationUnit,
  MessageDescriptor
> = {
  hours: msg`h`,
  minutes: msg`min`,
};
